import {ReactNode} from "react";

export interface ICommonType {

}

export type KeyOf<T extends object> = Extract<keyof T, string>;

export interface IError {
    error: boolean,
    msg: null | string
}


export interface IApiArgosId {
    accounts: string[],
    createTime: Date,
    ethAddress: string
    objectId: string
    statusCode: number
    updateTime: Date,
    userName: string
    userId?: string
}


export enum IIdStatus {
    notApproved = 'not approved',
    expired = 'expired',
    approved = 'approved',
    pending = 'pending',
    rejected = 'rejected',
    incomplete = 'incomplete'
}

export interface ICertificate {
    statusCode: number | null
    idStatus: IIdStatus
    message ?: string
    argosId ?: string
}


export type IProjectStatus = 'service' | 'trial' | 'closed' | ''

export interface IWallet {
    id ?: string
    address : string,
    chainId : string,
    coinName :string,
    walletName : string,
    coinTicker : string,
}

export type IActivityCoins = {
    option_bscAddress: boolean
    option_ethAddress: boolean
    option_klayAddress: boolean
    option_maticAddress: boolean
    option_solAddress: boolean
}


export interface IUser {
    objectId : string,
    id: string,
    argosId ?: string,
    className: string
}

export interface IAcceptCoinTable {
    network : string
    ticker : string
    fullName : string
}

export type ChainId = '0x38' | "0x1" | '0x89' | '0x2019' | 'sol' | ''

export interface ICurrentSelectNetwork {
    chainId: ChainId,
    name: 'Binance Smart Chain Mainnet' | 'Ethereum' | 'Polygon Mainnet' | 'Klaytn Mainnet Cypress' | 'Solana' | "",
    logo: ReactNode | null
    networkUrl: string,
    symbol : string,
    blockExplorerUrls : string,
    nativeCurrency: {
        name: string,
        symbol: string,
        decimals: 18
    }
}